import isEmpty from 'lodash-es/isEmpty';
import isUndefined from 'lodash-es/isUndefined';
import { ContainmentError } from '../../containmentError';
import { findNearestElement } from '../dom/node';
import { clampRange } from '../dom/range';
import { combineStyle } from './combineStyle';
import { DEFAULT_STYLE, getStyleFromElement, Style } from './style';

export function getStyleFromRange(container: Node, uncontainedRange: Range): Style {
  let range;

  try {
    range = clampRange(uncontainedRange, container);
  } catch (err) {
    // Since this is a getter, prefer to just return a fallback value than crash.
    if (err instanceof ContainmentError) {
      range = null;
    } else {
      throw err;
    }
  }

  if (!range) {
    return DEFAULT_STYLE;
  }

  const commonAncestorNode = range.commonAncestorContainer;
  const commonAncestorElement = findNearestElement(commonAncestorNode, container);
  if (!commonAncestorElement) {
    return DEFAULT_STYLE;
  }

  if (commonAncestorNode.nodeType === Node.TEXT_NODE) {
    return getStyleFromElement(container, commonAncestorElement);
  }

  const document = commonAncestorElement.ownerDocument;
  if (!document) {
    return DEFAULT_STYLE;
  }

  const walker = document.createTreeWalker(commonAncestorElement, NodeFilter.SHOW_TEXT);
  let node: Node | null;

  let style: Style | undefined;
  if (commonAncestorElement === range.startContainer || commonAncestorElement === range.endContainer) {
    style = getStyleFromElement(container, commonAncestorElement);
  }

  while ((node = walker.nextNode())) {
    if (!range.intersectsNode(node)) {
      continue;
    }

    const element = findNearestElement(node, container);
    if (!element) {
      continue;
    }

    style = isUndefined(style)
      ? getStyleFromElement(container, element)
      : combineStyle(style, getStyleFromElement(container, element));
    if (isEmpty(style)) {
      break;
    }

    if (node === range.endContainer) {
      break;
    }
  }

  return style || DEFAULT_STYLE;
}
